import { gql } from '@apollo/client';

export const AGE_GROUP_FIELDS = gql`
  fragment AgeGroupFields on AgeGroup {
    _id
    name
    assessmentId
  }
`;

// Given ids, the server answers literally: those of them that are live and in the assessment.
export const GET_AGE_GROUPS_IN_ASSESSMENT = gql`
  query GetAgeGroupsInAssessment($assessmentId: ID!, $ageGroupIds: [ID!]!) {
    ageGroups(assessmentId: $assessmentId, ageGroupIds: $ageGroupIds) {
      _id
      assessmentId
    }
  }
`;

export const GET_AGE_GROUPS = gql`
  query GetAgeGroups($assessmentId: ID!, $ageGroupIds: [ID!]) {
    ageGroups(assessmentId: $assessmentId, ageGroupIds: $ageGroupIds) {
      _id
      name
      assessmentId
      bucket
      currentStageNum
      numPlayers
      numGoalies
    }
  }
`;

// The two fields the accordion's Select is controlled by — both fully known from a
// setAgeGroupBucket request, so the mutation writes them before the network resolves.
export const AGE_GROUP_BUCKET_CHOICE = gql`
  fragment AgeGroupBucketChoice on AgeGroupBucketSetting {
    bucket
    isBucketManual
  }
`;

export const GET_AGE_GROUP_BUCKET_SETTINGS = gql`
  query GetAgeGroupBucketSettings($assessmentId: ID!) {
    ageGroupBucketSettings(assessmentId: $assessmentId) {
      options
      ageGroups {
        _id
        name
        assessmentId
        assessmentName
        bucket
        isBucketManual
        suggestedBucket
        matchType
      }
    }
  }
`;

export const SET_AGE_GROUP_BUCKET = gql`
  mutation SetAgeGroupBucket($_id: ID!, $value: String) {
    setAgeGroupBucket(_id: $_id, value: $value) {
      _id
      bucket
      isBucketManual
    }
  }
`;

export const CREATE_AGE_GROUP = gql`
  mutation CreateAgeGroup($data: CreateAgeGroupInput!) {
    createAgeGroup(data: $data) {
      ...AgeGroupFields
    }
  }

  ${AGE_GROUP_FIELDS}
`;

// null clears the age group's own choice, so it follows the assessment or association default again.
export const UPDATE_AGE_GROUP_INCLUDE_NON_CONCLUDED = gql`
  mutation UpdateAgeGroupIncludeNonConcluded($_id: ID!, $value: Boolean) {
    updateAgeGroup(_id: $_id, data: { reportCardsIncludeNonConcluded: $value }) {
      _id
      reportCardsIncludeNonConcluded
    }
  }
`;

export const UPDATE_AGE_GROUP = gql`
  mutation UpdateAgeGroup($_id: ID!, $data: UpdateAgeGroupInput!) {
    updateAgeGroup(_id: $_id, data: $data) {
      ...AgeGroupFields
    }
  }

  ${AGE_GROUP_FIELDS}
`;

export const GET_AGE_GROUP_JERSEY_RETENTION = gql`
  query GetAgeGroupJerseyRetention($assessmentId: ID!) {
    ageGroups(assessmentId: $assessmentId) {
      _id
      name
      retainJerseyAssignments
    }
  }
`;

export const SET_AGE_GROUP_JERSEY_RETENTION = gql`
  mutation SetAgeGroupJerseyRetention($_id: ID!, $data: UpdateAgeGroupInput!) {
    updateAgeGroup(_id: $_id, data: $data) {
      _id
      retainJerseyAssignments
    }
  }
`;
